function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec26d"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec26d"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $1834e192903f2901$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"i5gQ6":"index.bb1527fa.js","1lMe3":"selectable.ab495fec.png","9FJlh":"frozen.14053991.png","kMEEr":"wall.5c5c003b.png","9tZef":"v_wall.2e451ec2.png","cFOyN":"Frodon.63d11b25.png","lMJiL":"Gandalf.74d7a3f4.png","ehUSb":"Gollum.727c9862.png","GacQI":"Sam.8e5d74d4.png","734WI":"Arwen.d91ae142.png","f232s":"FrodonIcon.8bc866f6.png","3SHkZ":"GandalfIcon.a439ad78.png","cYBGV":"GollumIcon.5524e47a.png","78B1d":"SamIcon.e87ffc8a.png","5M8iY":"ArwenIcon.241294ce.png","4Xlyv":"undiscovered.48d1d2e5.png","f5jbI":"guard_case.4a548535.png","WjeY6":"player_case.0af453eb.png","4iV9z":"normal.3bc7f859.png","27zrS":"low_speed.e2d26280.png","lLwF1":"camera.e0e8729b.png","33XPU":"camera_off.fffceca6.png","aPMtC":"stop.e2d26280.png","hL5W4":"explode.ee2db5d6.png","7gqvj":"explode_green.df8dc6f5.png","2GWFo":"explode_orange.22d5e07c.png","ioF1A":"explode_red.90578891.png","kMz6b":"chest.d88f2760.png","iO0nN":"chest_open.d04fb6af.png","9k7ag":"key.d849dd3d.png","3SmO9":"speed_potion.35a03c75.png","aiQh8":"tree.31357d5a.png","aajcc":"teleporter.558d418d.png","5ZA19":"teleporter_red.859ef6bd.png","1URl3":"teleporter_green.cc9d0a4a.png","dDD01":"book.1e1a3dd9.png","7U5M2":"machine.0a2e6596.png","5Bu5N":"bague.a6844ef8.png","jlt6o":"task.fecdee54.png","5ETGS":"task_done.afbf4f9e.png","cxQFW":"unfreeze_potion.c49ef222.png","6WV6V":"leaf.281768b1.png","ep0Eu":"beetle.c313b0cf.png","7Crti":"trash.12d40ae1.png","8vwqu":"sick.6f58e783.png","fTATm":"spawn.cdc4060d.png","4YcwK":"hammer.27107222.png","bD1XH":"mazeDeco1.b4577b02.png","5jJ8W":"mazeDeco2.1c9a2c13.png","jJVo0":"mazeDeco3.4313c3d9.png","bCRYU":"mazeFloor.5d1580d4.png","bqmqt":"mazeFloor2.d0dc327e.png","e7DtW":"mazeFloor50x50.e563ec00.png","67FVA":"mazeFontain.4c750226.png","cEmlE":"mazeMap.975752a8.png","5kGXC":"mazeWater.a19814b5.png","6geeL":"niche.1be6c0e0.png","4WwJK":"niche2.1be6c0e0.png","g72Qe":"torch_off.a1620325.png","1D0Z0":"torch_on.eb68e577.png","hyAfX":"whale.b9716141.png","hIpFy":"whale2.e378514f.png","3Xfuk":"walk.7d35cf67.mp3","gBAtU":"activate.a7aa632e.mp3","1tTnY":"break_wall.2b49fb18.mp3","35g1k":"game_over.f398a682.mp3","h3bjX":"open_chest.1087475b.mp3","iQI6Q":"freeze_player.f398a682.mp3","7KJNZ":"trigger_trap.e4638b69.mp3","lqJey":"Ghost.e5aa6832.png","iJsu9":"Guard.d809e87c.png","7qeRD":"Pion.757a1e22.png"}'));


//# sourceMappingURL=index.8e275c80.js.map
